import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.scss";
import Container from "./Container.jsx";

function App() {
  return (
    <Router>
      <div id="app">
        <Container />
      </div>
    </Router>
  );
}

export default App;
